import featureFlags from '../../feature-flags'
import { useAuth } from './useAuth'

const isFeatureVisible = (name, isDesktop) => {
  if (name === 'Peer Stories' && featureFlags.peerStories !== 'active') {
    return false
  }
  if (name === 'Learning Center' && featureFlags.learningCenter !== 'active') {
    return false
  }
  if (
    name === 'Maintenance Package' &&
    featureFlags.maintenancePackage !== 'active'
  ) {
    return false
  }
  if (
    name === 'Brand Studio Services' &&
    featureFlags.commonwealthServices !== 'active'
  ) {
    return false
  }
  if (
    name === 'SB Recommended Resources' &&
    featureFlags.sbRecommendedResources !== 'active'
  ) {
    return false
  }
  if (name === 'Admin Tools') {
    const { isAdmin } = useAuth()
    return isAdmin
  }
  if (
    name === 'Service Package' &&
    featureFlags.servicePackageDocusign !== 'active'
  ) {
    return false
  }
  if (
    name === 'Easysite Request Form' &&
    featureFlags?.easysiteRequestForm !== 'active'
  ) {
    return false
  }
  if (
    name === 'Website Services Redesign' &&
    featureFlags.websiteServicesRedesign !== 'active'
  ) {
    return false
  }
  if (name !== 'Strategy Builder') {
    return true
  }
  //from here, are scenarios for strategy builder link only
  if (featureFlags.strategyBuilder !== 'active') {
    return false
  }

  if (!isDesktop) {
    //Strategy builder is not compatible with mobile/tablet
    return false
  }
  return true
}

export default isFeatureVisible
